import React, { memo, useRef } from "react";
import PropTypes from "prop-types";
import { SliderField, Typography } from "investira.react.components";
import InputField from "./InputField";
import { useFormikContext } from "formik";

/**
 * Renderiza o componente SliderInputField.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {string} props.label - Texto exibido como rótulo do componente.
 * @param {number} props.value - Valor exibido ou controlado pelo componente.
 * @param {number} props.max - Propriedade `max` do componente.
 * @param {string} props.variant - Variante visual ou de comportamento do componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
const SliderInputField = memo((props) => {
  const context = props.context;

  const timeout = useRef(null);

  function handleChange(pName, pValue) {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }

    const { setFieldValue } = context;

    timeout.current = setTimeout(() => {
      setFieldValue(props.name, pValue);
      props.onChange && props.onChange(props.name, pValue, context);
    }, 300);
  }

  return (
    <div>
      <Typography
        id="non-linear-slider"
        variant="caption"
        color="textSecondary"
        gutterBottom
      >
        {props.label}
      </Typography>

      {props.variant === "slider" && (
        <SliderField
          min={0}
          name={props.name}
          max={props.max}
          step={1}
          value={props.value}
          valueSuffix={props.valueSuffix}
          onChange={handleChange}
          disabled={props.disabled}
        />
      )}

      {props.variant === "input" && (
        <InputField
          value={props.value}
          name={props.name}
          onChange={(value) => {
            console.log(value);
          }}
          maxLength={props.maxLength}
          disabled={props.disabled}
        />
      )}
    </div>
  );
});

SliderInputField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  max: PropTypes.number,
  variant: PropTypes.oneOf(["slider", "input"]),
};

SliderInputField.defaultProps = {
  label: "",
  value: 0,
  max: 100,
  variant: "slider",
};

SliderInputField.displayName = "SliderInputField";

export default SliderInputField;
